<!-- Phase 3 create-modal template: BUI-styled form content hosted inside the
     shared Dialog.vue wrapper (see PlayerSubscriptionsListView.vue). -->

<template>
  <div class="create-subscription-form">
    <StatusBar
      :errorMessage="errorMessage"
      :isLoading="isLoading"
      loadingMessage="Saving..."
      :isSuccess="isSuccess"
      successMessage="Saved!"
    />
    <div class="field-content">
      <!-- TODO: think about adding below-field error message & error state indication (e.g. red border) [DSP-N26CxI4P] -->
      <div class="d-flex field-row">
        <label for="csf-name" class="basis-1/2 text-sm font-bold">Name &#9733;</label>
        <TextField id="csf-name" name="name" data-test-id="subscription-name" v-model="values.name" class="basis-1/2" width="100%" />
      </div>
    </div>

    <!-- Players Filters -->
    <div class="csf-section-title">Target Players Filters</div>
    <PlayersFilters v-model="values.filters" />

    <div class="form-buttons">
      <ButtonCustomized label="Cancel" data-testid="subscription-cancel" @click="onCancel" ctaSecondary />
      <ButtonCustomized label="Create" data-testid="subscription-create" cta @click="onSubmit" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import TextField from "@/components/form-fields/TextField.vue";
import ButtonCustomized from "@/components/form-fields/ButtonCustomized.vue";
import StatusBar from "@/components/form-fields/StatusBar/StatusBar.vue";
import PlayersFilters from "@/views/PlayerSubscriptionEditorView/PlayersFilters/PlayersFilters.vue";

import { useCreateSubscriptionFormHelpers } from "./composables/createSubscriptionFormHelpers";
import useNotifications from "@/components/Notifications/composables/notifications";

import router from '@/router';


const emit = defineEmits(['submit', 'cancel', 'success', 'fail'])

const notification = useNotifications();

const { values, submitForm, isLoading, isSuccess, errorMessage, newSubscriptionId } = useCreateSubscriptionFormHelpers();

async function onSubmit() {
  await submitForm();
  if(isSuccess.value === true) {
    notification.success('Player Subscription created successfully!');
    emit('success');
    router.push({name: 'player-subscription-editor', params: {id: newSubscriptionId.value}});
  } else {    // on failure
    emit('fail');
  }
}

function onCancel() {
  emit('cancel');
}
</script>

<style lang="scss" scoped>
.create-subscription-form {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  width: min(32rem, calc(100vw - 6rem));
  color: var(--bui-tbl-row-text, #2a2969);
}

.csf-section-title {
  margin-top: 0.5rem;
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--bui-tbl-detail-text, #5c5c66);
}

.field-content {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;

  :deep(.field label) {
    color: var(--bui-tbl-row-text, #2a2a30);
  }

  :deep(.field input[type='text']) {
    color: var(--bui-ter-input-text, #1a1a1e);
    background: var(--bui-ter-input-fill, rgba(0, 0, 0, 0.04));
    border-color: var(--bui-ter-input-border, rgba(0, 0, 0, 0.12));
    width: 100%;
  }
}

.field-row {
  align-items: center;

  label {
    color: var(--bui-tbl-row-text, #2a2a30);
  }
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}
</style>
